import React from "react"
import {Col, Row} from 'reactstrap';

const PageHeader = ({title, subtitle = null}) => {

    return (
        <Row>
            <Col>
                <h1>{title}</h1>
                <p>
                    {(subtitle ? subtitle : 'Settings are automatically saved upon changes')}
                </p>
            </Col>
        </Row>
    )
}

export default PageHeader;



// WEBPACK FOOTER //
// ./src/new-components/admin/page-header.js